module.exports = __webpack_public_path__ + "./images/46bdd531ee52020cc99d167c36a02843.webp";